import React from 'react';
import { useNotifications } from '../hooks/useNotifications';
import './NotificationSettings.css';

const NotificationSettings: React.FC = () => {
  const {
    isSupported,
    permission,
    token,
    isLoading,
    error,
    enableNotifications,
    disableNotifications,
  } = useNotifications();

  if (!isSupported) {
    return (
      <div></div>
    );
  }

  const getPermissionStatus = () => {
    switch (permission) {
      case 'granted':
        return '✅ Đã bật';
      case 'denied':
        return '❌ Đã tắt';
      default:
        return '⚠️ Chưa thiết lập';
    }
  };

  const getPermissionColor = () => {
    switch (permission) {
      case 'granted':
        return '#4CAF50';
      case 'denied':
        return '#f44336';
      default:
        return '#ff9800';
    }
  };

  return (
    <div className="notification-settings">
      <div className="notification-header">
        <h3>🔔 Cài đặt thông báo</h3>
        <div 
          className="permission-status"
          style={{ color: getPermissionColor() }}
        >
          {getPermissionStatus()}
        </div>
      </div>

      <div className="notification-content">
        <p className="notification-description">
          Nhận thông báo về nhiệm vụ mới, phần thưởng, và cập nhật game từ KILOBA Hub.
        </p>

        {error && (
          <div className="notification-error">
            <span className="error-icon">⚠️</span>
            <span>{error}</span>
          </div>
        )}

        <div className="notification-actions">
          {permission !== 'granted' ? (
            <button
              className="notification-btn notification-btn-enable"
              onClick={enableNotifications}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  Đang bật...
                </>
              ) : (
                <>
                  <span className="btn-icon">🔔</span>
                  Bật thông báo
                </>
              )}
            </button>
          ) : (
            <div className="notification-enabled">
              <div className="token-info">
                <span className="token-label">Device Token:</span>
                <span className="token-value">
                  {token ? `${token.substring(0, 20)}...` : 'Không có'}
                </span>
              </div>
              
              <button
                className="notification-btn notification-btn-disable"
                onClick={disableNotifications}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Đang tắt...
                  </>
                ) : (
                  <>
                    <span className="btn-icon">🔕</span>
                    Tắt thông báo
                  </>
                )}
              </button>
            </div>
          )}
        </div>

        <div className="notification-features">
          <h4>Loại thông báo:</h4>
          <ul>
            <li>🎯 Nhiệm vụ mới và cập nhật tiến độ</li>
            <li>🎁 Phần thưởng và voucher mới</li>
            <li>🏆 Thành tích và xếp hạng</li>
            <li>🎮 Sự kiện và mini-game mới</li>
            <li>📱 Cập nhật ứng dụng</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
